import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from '../../models/question/question-base';

@Component({
    selector: 'app-dynamic-form-question',
    templateUrl: './dynamic-form-question.component.html',
    styleUrls: ['./dynamic-form-question.component.css']
})
export class DynamicFormQuestionComponent {
    @Input() question: QuestionBase<any>;
    _form: FormGroup;

    isValid() {
        return this.form.controls[this.question.id].valid;
    }

    get form(): FormGroup {
        return this._form;
    }

    @Input()
    set form(form: FormGroup) {
        this._form = form;
    }

    constructor(
    ) { }
}
